import { Modal } from 'antd'
import styled from 'styled-components'

export const ContainerPontosColeta = styled.div`
  width: 100%;
  flex: 1;
  min-height: 0;
  display: flex;
  gap: 12px;
  margin-top: 10px;
  padding-bottom: 12px;
`

export const ModalMalhaGeral = styled(Modal)`
  height: 95vh;

  .ant-modal-content {
    border-radius: 12px;
    /* padding: 4px; */
    height: 100%;
    overflow: hidden;
    display: flex;
    flex-direction: column;
  }

  .ant-modal-body {
    flex: 1;
    overflow: hidden;
    display: flex;
    flex-direction: column;
  }

  .ant-modal-header {
    margin: 0;
  }

  .ant-modal-footer{
    margin-top: 0px;
  }

  .title {
    display: flex;
    padding-left: 24px;
    padding-right: 24px;
    padding-top: 16px;
    justify-content: space-between;
    align-items: center;


    h3 {
      font-size: 17px;
      font-weight: 600;
      margin: 0;
      padding: 0;
    }
  }

  .modal_infos {
    display: flex;
    height: 30px;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 10px;
    padding-left: 15px;
    padding-right: 15px;

    div {
      display: flex;
      height: 50px;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      padding: 15px;

      label {
        font-size: 12px;
        font-weight: 500;
        color: #7b7b7b;
        padding: 0;
        margin: 0;
      }

      p {
        padding: 0;
        margin: 0;
        line-height: 1.1;
        font-size: 13px;
        font-weight: 600;
      }
    }
  }
`

export const FooterModal = styled.div`
  flex-shrink: 0;
  height: 45px;
  display: flex;
  align-items: flex-end;
  justify-content: flex-end;
  border-top: 1px solid var(--border-color);
`

export const ColunaMapa = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
`

export const WrapperMapa = styled.div<{ $fullscreen: boolean }>`
  position: relative;
  width: 100%;
  height: 100%;
  border-radius: ${({ $fullscreen }) => ($fullscreen ? 0 : '8px')};
  background-color: white;
`

export const AcoesInfo = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 10px;
`
